import { Link } from "react-router-dom";
import logoFull from "../../assets/logo-full.png";

export function Logo() {
  return (
    <Link
      to="/inicio"
      className="mx-1 flex min-w-0 shrink items-center outline-none focus-visible:ring-2 focus-visible:ring-emerald-400/50 focus-visible:ring-offset-2 focus-visible:ring-offset-zinc-950 rounded-md"
    >
      <img
        src={logoFull}
        alt="Aprender e Capacitar Brasil"
        className="h-9 w-auto max-w-[200px] object-contain object-left drop-shadow-md sm:h-10 sm:max-w-[220px]"
        width={560}
        height={240}
        decoding="async"
        loading="eager"
      />
    </Link>
  );
}
